import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import ChapterOrigem from "@/components/site/ChapterOrigem";
import ChapterProcesso from "@/components/site/ChapterProcesso";
import ChapterColecao from "@/components/site/ChapterColecao";
import ChapterEncomendas from "@/components/site/ChapterEncomendas";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main className="relative min-h-screen bg-[var(--bg)] text-[var(--ink)]" data-testid="home-root">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <ChapterOrigem />
      <ChapterProcesso />
      <ChapterColecao />
      <ChapterEncomendas />
      <Footer />
    </main>
  );
}
